var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('div', {
    class: _vm.expand ? 'search' : null
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.where,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    class: _vm.expand ? null : 'fold'
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: _vm.where.status,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "status", $$v);
      },
      expression: "where.status"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _c('a-select-option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "prop": "companyName",
      "label": "公司名称"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公司名称"
    },
    model: {
      value: _vm.where.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "companyName", $$v);
      },
      expression: "where.companyName"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "prop": "perName",
      "label": "人员名称"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入人员名称"
    },
    model: {
      value: _vm.where.perName,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "perName", $$v);
      },
      expression: "where.perName"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.fetch({
          current: 1,
          pageSize: 10
        });
      }
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v("重置")])], 1)])], 1)]), _c('a-card', {
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card",
    attrs: {
      "size": "middle",
      "row-key": function rowKey(row) {
        return row.id;
      },
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "data-source": _vm.data,
      "bordered": "",
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.onChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function fn(text, row) {
        return [0 === row.status ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("停用")]) : _vm._e(), 1 === row.status ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("启用")]) : _vm._e()];
      }
    }, {
      key: "action",
      fn: function fn(text, row) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作 "), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.viewOuterPerson(row);
            }
          }
        }, [_vm._v("查看")])], 1), _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.updateStatus(row);
            }
          }
        }, [_vm._v(_vm._s(row.status == 1 ? '停用' : '启用'))])], 1), _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.outerPersonModel(row);
            }
          }
        }, [_vm._v("编辑")])], 1), 0 === row.status ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.delOuterMaintain(row);
            }
          }
        }, [_vm._v("删除")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  }, [_c('template', {
    slot: "title"
  }, [_c('a-button-group', [_c('a-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.outerPersonModel
    }
  }, [_vm._v("新建")])], 1)], 1)], 2)], 1), _c('a-modal', {
    attrs: {
      "title": _vm.visibleTitle,
      "width": "35%",
      "centered": true,
      "maskClosable": _vm.isView,
      "footer": _vm.isView ? null : undefined
    },
    on: {
      "ok": _vm.submitOuterPerson
    },
    model: {
      value: _vm.visibleMode,
      callback: function callback($$v) {
        _vm.visibleMode = $$v;
      },
      expression: "visibleMode"
    }
  }, [_c('div', [_c('a-form-model', {
    ref: "addForm",
    attrs: {
      "model": _vm.formObject,
      "rules": _vm.rules,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "人员名称",
      "prop": "perName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入人员名称",
      "max-length": 50
    },
    model: {
      value: _vm.formObject.perName,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "perName", $$v);
      },
      expression: "formObject.perName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("联系电话 "), _c('a-tooltip', [_c('template', {
    slot: "title"
  }, [_vm._v(" 默认登录密码为： "), _c('div', [_vm._v("1、YCoa@+手机后4位")]), _c('div', [_vm._v("2、编辑手机号不会重置为默认密码")])]), _c('a-icon', {
    staticStyle: {
      "margin": "11px 5px",
      "color": "blue",
      "cursor": "pointer"
    },
    attrs: {
      "type": "question-circle"
    }
  })], 2)], 1), _c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入联系电话",
      "max-length": 11
    },
    model: {
      value: _vm.formObject.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "phone", $$v);
      },
      expression: "formObject.phone"
    }
  })], 2), _c('a-form-model-item', {
    attrs: {
      "label": "公司名称",
      "prop": "companyName"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公司名称",
      "max-length": 50
    },
    model: {
      value: _vm.formObject.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "companyName", $$v);
      },
      expression: "formObject.companyName"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "公司电话",
      "prop": "companyPhone"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入公司电话",
      "max-length": 21
    },
    model: {
      value: _vm.formObject.companyPhone,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "companyPhone", $$v);
      },
      expression: "formObject.companyPhone"
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入备注,字数限制200",
      "max-length": 200,
      "rows": 4
    },
    model: {
      value: _vm.formObject.remark,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject, "remark", $$v);
      },
      expression: "formObject.remark"
    }
  })], 1)], 1)], 1)]), _c('a-modal', {
    attrs: {
      "title": "查看校外人员",
      "width": "35%",
      "centered": true,
      "footer": null
    },
    model: {
      value: _vm.visibleViewMode,
      callback: function callback($$v) {
        _vm.visibleViewMode = $$v;
      },
      expression: "visibleViewMode"
    }
  }, [_c('div', {
    staticClass: "view-desc"
  }, [_c('a-descriptions', {
    attrs: {
      "column": 1,
      "bordered": ""
    }
  }, [_c('a-descriptions-item', {
    attrs: {
      "label": "人员名称"
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.perName || '') + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.phone || '') + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "公司名称"
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.companyName || '') + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "公司电话"
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.companyPhone || '') + " ")]), _c('a-descriptions-item', {
    attrs: {
      "label": "备注"
    }
  }, [_vm._v(" " + _vm._s(_vm.formObject.remark || '') + " ")])], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };